import { apiClient } from './client';
import type { POSLocation, ReceiptMethod } from './types';

export const locationsApi = {
  async list(): Promise<{ locations: POSLocation[]; total: number }> {
    return apiClient.request<{ locations: POSLocation[]; total: number }>('/locations');
  },

  async enable(
    locationId: number,
    data: {
      displayName?: string;
      currency?: string;
      taxZoneId?: number;
      defaultReceiptMethod?: ReceiptMethod;
      requireCustomerEmail?: boolean;
      requireCustomerPhone?: boolean;
      paymentMethods?: Partial<{
        cash: boolean;
        card: boolean;
        manualCard: boolean;
        giftCard: boolean;
        storeCredit: boolean;
      }>;
      tip?: {
        enabled?: boolean;
        options?: number[];
      };
    }
  ): Promise<{
    locationId: number;
    displayName: string;
    currency: string;
    isActive: boolean;
  }> {
    return apiClient.request(`/locations/${locationId}/enable`, {
      method: 'POST',
      body: data,
    });
  },

  async update(
    locationId: number,
    data: {
      displayName?: string;
      currency?: string;
      taxZoneId?: number;
      defaultReceiptMethod?: ReceiptMethod;
      requireCustomerEmail?: boolean;
      requireCustomerPhone?: boolean;
      paymentMethods?: Partial<{
        cash: boolean;
        card: boolean;
        manualCard: boolean;
        giftCard: boolean;
        storeCredit: boolean;
      }>;
      tip?: {
        enabled?: boolean;
        options?: number[];
      };
    }
  ): Promise<{
    locationId: number;
    displayName: string;
    currency: string;
    isActive: boolean;
  }> {
    return apiClient.request(`/locations/${locationId}`, {
      method: 'PUT',
      body: data,
    });
  },

  async disable(locationId: number): Promise<{ success: boolean }> {
    return apiClient.request<{ success: boolean }>(`/locations/${locationId}`, {
      method: 'DELETE',
    });
  },

  async assignDevice(locationId: number, deviceId: string): Promise<{ success: boolean }> {
    return apiClient.request<{ success: boolean }>(
      `/locations/${locationId}/assign-device`,
      {
        method: 'POST',
        body: { deviceId },
      }
    );
  },
};
